import React, { useContext, useEffect, useState } from "react";
import '../components/FrontProductsBlock.css';
import '../components/Catalog/catpanel.css';
import '../components/catalog.css';
import {observer} from "mobx-react-lite";
import {Context} from "..";
// import {getStore, getStores, hasRole} from "../http/userAPI";
import TopBanner from '../components/TopBannerSliders/TopBanner';
import CatPanel from '../components/Catalog/CatPanel';
import FastLinkBar from '../components/FastLinkBar';
import FrontProductsBlock from '../components/FrontProductsBlock';
import { useProductsLoader } from "../hooks/useProductsLoader";


const Home = observer(() => {

  const { product } = useContext(Context);
  const [filtersFromURLLoaded, setFiltersFromURLLoaded] = useState(false); // что бы не запрашивались 2 раза по типу loading

      useEffect(() => {
          // ОБЯЗАТЕЛЬНО ВНУТРИ useEffect          
          product.setSelectedFilters(null);
          product.setSelectedFolder({ id: "2" });
          setFiltersFromURLLoaded(true); // запускаем useProductsLoader
      }, []); // Выполнится один раз при монтировании

  useProductsLoader(filtersFromURLLoaded); // запуск загрузки продуктов
    
        return (
        <>
            <TopBanner /><CatPanel /><FastLinkBar /><FrontProductsBlock />
        </>
    );
});

export default Home;